import { watchingForReplyLine, watchingLine, whenLabel } from '@pa/core';
import type { ScheduleView } from './api';

/** "Reminder · Thursday 9:00", "Watching · next check in 4 min", "Daily brief · 07:30" (M5). */
export function scheduleLine(s: ScheduleView, lang: 'en' | 'ar', now = new Date()): string {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Qatar';
  if (s.kind === 'reminder' && s.at) {
    const when = whenLabel(new Date(s.at), { now, timezone, lang });
    return lang === 'ar' ? `تذكير · ${when}` : `Reminder · ${when}`;
  }
  if (s.kind === 'brief') {
    return lang === 'ar' ? `الملخص اليومي · ${s.time ?? ''}` : `Daily brief · ${s.time ?? ''}`;
  }
  // M5.4: the reply watch names what it watches.
  if (s.watch === 'mail_reply' && s.next_run_at)
    return watchingForReplyLine(s.next_run_at, now, lang);
  if (s.next_run_at) return watchingLine(s.next_run_at, now, lang);
  return lang === 'ar' ? 'يراقب' : 'Watching';
}
